<template>
  <list-messages :count="0" />
</template>

<script>
import ListMessages from './list-messages';
export default {
  name: 'sent-messages',
  components: { ListMessages }
};
</script>

<style scoped></style>
